// extracted by mini-css-extract-plugin
export var arrows = "_20-6";
export var decrementer = "_20-a";
export var disabled = "_20-4";
export var error = "_20-1";
export var hiddenText = "_20-b";
export var incrementer = "_20-9";
export var input = "_20-8";
export var inputWrapper = "_20-0";
export var leadingIcon = "_20-c";
export var readonly = "_20-3";
export var regular = "_20-7";
export var small = "_20-5";
export var warning = "_20-2";